import React from "react";
import { Button } from "semantic-ui-react";

import CalcParm1_PSM3 from "./CalcParm1_PSM3";
import CalcParm2_PSM3 from "./CalcParm2_PSM3";
import CalcParm3_PSM3 from "./CalcParm3_PSM3";
import ConfigTags_PSM3 from "./ConfigTags_PSM3";

const CalParm_PSM3 = () => {
  const [toggleButton, setToggleButton] = React.useState("1");

  const handleClick = (e, { id }) => {
    setToggleButton(id);
  };

  const renderSwitch = (param) => {
    switch (param) {
      case "1":
        return <CalcParm1_PSM3 />;
      case "2":
        return <CalcParm2_PSM3 />;
      case "3":
        return <CalcParm3_PSM3 />;
      case "4":
        return <ConfigTags_PSM3 />;
      default:
        return <CalcParm1_PSM3 />;
    }
  };

  return (
    <div style={styles.div}>
      <Button.Group toggle style={styles.toggle}>
        <Button
          size="medium"
          id="1"
          active={toggleButton === "1"}
          onClick={handleClick}
          content="Calculated Parameter Page - 1"
        />
        <Button
          size="medium"
          id="2"
          active={toggleButton === "2"}
          onClick={handleClick}
          content="Calculated Parameter Page - 2"
        />
        <Button
          size="medium"
          id="3"
          active={toggleButton === "3"}
          onClick={handleClick}
          content="Calculated Parameter Page - 3"
        />
        <Button
          size="medium"
          id="4"
          active={toggleButton === "4"}
          onClick={handleClick}
          content="Configuration Tags"
        />
      </Button.Group>
      {renderSwitch(toggleButton)}
    </div>
  );
};

const styles = {
  div: {
    textAlign: "center",
  },
  toggle: {
    marginLeft: "8px",
  },
};

export default CalParm_PSM3;
